export default __webpack_public_path__ + "static/1-adb154c1ee7437ce24830bdf23f4e9f3.jpeg";